<template>
  <div class="mdl-card fill">
    <div class="mdl-card__title">
      <h2 class="mdl-card__title-text">{{'admin.parameters.title.label' | label}}</h2>
    </div>
    <div class="mdl-card__supporting-text fill">
      <validator name="parametersValidator">
        <form novalidate>
          <div class="mdl-grid">
            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-label">
                {{ 'admin.config.defaultLang' | label }}
              </div>
            </div>
            <div class="mdl-cell mdl-cell--6-col">
              <div style="padding-bottom: 20px;">
                <lookup-select name="defaultLang" :value.sync="defaultLang" options="LANG" :preselected="defaultLang"></lookup-select>
              </div>
            </div>
            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-label">
                {{ 'admin.config.maxFileSize' | label }}
              </div>
            </div>
            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
                <input class="mdl-textfield__input" type="text" id="maxFileSize" v-model="maxFileSize" initial="off"
                       v-validate:maxFileSize="['required']">
                <span class="validation-error mdl-textfield__error" v-if="$parametersValidator.maxfilesize.required">
                  {{'general.label.validation.required' | label}}</span>
              </div>
            </div>
            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-label">
                {{ 'admin.config.allowFileTypes' | label }}
              </div>
            </div>
            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
                <input class="mdl-textfield__input" type="text" id="fileTypes" v-model="fileTypes" initial="off"
                       v-validate:fileTypes="['required']">
                <span class="validation-error mdl-textfield__error" v-if="$parametersValidator.filetypes.required">
                  {{'general.label.validation.required' | label}}</span>
              </div>
            </div>

            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-label">
                {{ 'admin.config.resetExpiryPeriod' | label }}
              </div>
            </div>
            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
                <input class="mdl-textfield__input" type="text" id="resetExpiryPeriod" v-model="resetExpiryPeriod" initial="off"
                       v-validate:resetExpiryPeriod="['required']">
                <span class="validation-error mdl-textfield__error" v-if="$parametersValidator.resetexpiryperiod.required">
                  {{'general.label.validation.required' | label}}</span>
              </div>
            </div>

            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-label">
                {{ 'admin.config.verifyExpiryPeriod' | label }}
              </div>
            </div>
            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
                <input class="mdl-textfield__input" type="text" id="verifyExpiryPeriod" v-model="verifyExpiryPeriod" initial="off"
                       v-validate:verifyExpiryPeriod="['required']">
                <span class="validation-error mdl-textfield__error" v-if="$parametersValidator.verifyexpiryperiod.required">
                  {{'general.label.validation.required' | label}}</span>
              </div>
            </div>

            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-label">
                {{ 'admin.config.delayExpiryPeriod' | label }}
              </div>
            </div>
            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
                <input class="mdl-textfield__input" type="text" id="delayExpiryPeriod" v-model="delayExpiryPeriod" initial="off"
                       v-validate:delayExpiryPeriod="['required']">
                <span class="validation-error mdl-textfield__error" v-if="$parametersValidator.delayexpiryperiod.required">
                  {{'general.label.validation.required' | label}}</span>
              </div>
            </div>

            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-label">
                {{ 'admin.config.maxLoginAttempts' | label }}
              </div>
            </div>
            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
                <input class="mdl-textfield__input" type="text" id="maxLoginAttempts" v-model="maxLoginAttempts" initial="off"
                       v-validate:maxLoginAttempts="['required']">
                <span class="validation-error mdl-textfield__error" v-if="$parametersValidator.maxloginattempts.required">
                  {{'general.label.validation.required' | label}}</span>
              </div>
            </div>

            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-label">
                {{ 'admin.config.userLockTimeInMin' | label }}
              </div>
            </div>
            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
                <input class="mdl-textfield__input" type="text" id="userLockTimeInMin" v-model="userLockTimeInMin" initial="off"
                       v-validate:userLockTimeInMin="['required']">
                <span class="validation-error mdl-textfield__error" v-if="$parametersValidator.userLockTimeInMin.required">
                  {{'general.label.validation.required' | label}}</span>
              </div>
            </div>

            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-label">
                {{ 'admin.config.maxSendAfterDays' | label }}
              </div>
            </div>
            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
                <input class="mdl-textfield__input" type="text" id="maxSendAfterDays" v-model="maxSendAfterDays" initial="off"
                       v-validate:maxSendAfterDays="['required']">
                <span class="validation-error mdl-textfield__error" v-if="$parametersValidator.maxsendafterdays.required">
                  {{'general.label.validation.required' | label}}</span>
              </div>
            </div>

            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-label">
                {{ 'admin.config.maxScheduledDays' | label }}
              </div>
            </div>
            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
                <input class="mdl-textfield__input" type="text" id="maxScheduledDays" v-model="maxScheduledDays" initial="off"
                       v-validate:maxScheduledDays="['required']">
                <span class="validation-error mdl-textfield__error" v-if="$parametersValidator.maxscheduleddays.required">
                  {{'general.label.validation.required' | label}}</span>
              </div>
            </div>

            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-label">
                {{ 'admin.config.maxMessageSize' | label }}
              </div>
            </div>
            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
                <input class="mdl-textfield__input" type="text" id="maxMessageSize" v-model="maxMessageSize" initial="off"
                       v-validate:maxMessageSize="['required']">
                <span class="validation-error mdl-textfield__error" v-if="$parametersValidator.maxmessagesize.required">
                  {{'general.label.validation.required' | label}}</span>
              </div>
            </div>

            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-label">
                {{ 'admin.config.maxUserStorageSizeMb' | label }}
              </div>
            </div>
            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
                <input class="mdl-textfield__input" type="text" id="maxUserStorageSizeMb" v-model="maxUserStorageSizeMb" initial="off"
                       v-validate:maxUserStorageSizeMb="['required']">
                <span class="validation-error mdl-textfield__error" v-if="$parametersValidator.maxUserStorageSizeMb.required">
                  {{'general.label.validation.required' | label}}</span>
              </div>
            </div>

            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-label">
                {{ 'admin.config.secondaryDelayWaitInMin' | label }}
              </div>
            </div>
            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
                <input class="mdl-textfield__input" type="text" id="secondaryDelayWaitInMin" v-model="secondaryDelayWaitInMin" initial="off"
                       v-validate:secondaryDelayWaitInMin="['required']">
                <span class="validation-error mdl-textfield__error" v-if="$parametersValidator.secondarydelaywaitinmin.required">
                  {{'general.label.validation.required' | label}}</span>
              </div>
            </div>

            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-label">
                {{ 'admin.config.scheduledDonations' | label }}
              </div>
            </div>
            <div class="mdl-cell mdl-cell--6-col">
              <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
                <input class="mdl-textfield__input" type="text" id="scheduledDonations" v-model="scheduledDonations" initial="off"
                       v-validate:scheduledDonations="['required']">
                <span class="validation-error mdl-textfield__error" v-if="$parametersValidator.scheduleddonations.required">
                  {{'general.label.validation.required' | label}}</span>
              </div>
            </div>

          </div>
        </form>
      </validator>
    </div>
    <div class="mdl-card__actions">
      <div class="submit-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored float-right"
           v-on:click="submit()">
        {{'admin.parameters.button.save' | label}}
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
  var api = require('api')
  module.exports = {
    ready: function () {
      var self = this
      api.AppConfig.get().then(function (response) {
        var config = response.data
        self.maxFileSize = config.maxFileSize
        self.fileTypes = config.fileTypes
        self.resetExpiryPeriod = config.resetExpiryPeriod
        self.verifyExpiryPeriod = config.verifyExpiryPeriod
        self.delayExpiryPeriod = config.delayExpiryPeriod
        self.maxLoginAttempts = config.maxLoginAttempts
        self.userLockTimeInMin = config.userLockTimeInMin
        self.maxSendAfterDays = config.maxSendAfterDays
        self.maxScheduledDays = config.maxScheduledDays
        self.defaultLang = config.defaultLang
        self.maxMessageSize = config.maxMessageSize
        self.maxUserStorageSizeMb = config.maxUserStorageSizeMb
        self.secondaryDelayWaitInMin = config.secondaryDelayWaitInMin
        self.scheduledDonations = config.scheduledDonations
      })
    },
    data: function () {
      return {
        maxFileSize: '',
        fileTypes: '',
        resetExpiryPeriod: '',
        verifyExpiryPeriod: '',
        delayExpiryPeriod: '',
        maxLoginAttempts: '',
        userLockTimeInMin: '',
        maxSendAfterDays: '',
        maxScheduledDays: '',
        maxMessageSize: '',
        maxUserStorageSizeMb: '',
        defaultLang: '',
        secondaryDelayWaitInMin: '',
        scheduledDonations: ''
      }
    },
    components: {
      lookupSelect: require('c/components/Select')
    },
    methods: {
      submit: function () {
        var self = this
        this.$validate(true, function () {
          if (self.$parametersValidator.invalid) {
            return
          }
          self.$dispatch('save-parameters', {
            appConfig: [
              {
                key: 'maxFileSize',
                value: self.maxFileSize
              },
              {
                key: 'fileTypes',
                value: self.fileTypes
              },
              {
                key: 'resetExpiryPeriod',
                value: self.resetExpiryPeriod
              },
              {
                key: 'verifyExpiryPeriod',
                value: self.verifyExpiryPeriod
              },
              {
                key: 'delayExpiryPeriod',
                value: self.delayExpiryPeriod
              },
              {
                key: 'maxSendAfterDays',
                value: self.maxSendAfterDays
              },
              {
                key: 'maxScheduledDays',
                value: self.maxScheduledDays
              },
              {
                key: 'defaultLang',
                value: self.defaultLang
              },
              {
                key: 'maxLoginAttempts',
                value: self.maxLoginAttempts
              },
              {
                key: 'userLockTimeInMin',
                value: self.userLockTimeInMin
              },
              {
                key: 'maxMessageSize',
                value: self.maxMessageSize
              },
              {
                key: 'maxUserStorageSizeMb',
                value: self.maxUserStorageSizeMb
              },
              {
                key: 'secondaryDelayWaitInMin',
                value: self.secondaryDelayWaitInMin
              },
              {
                key: 'scheduledDonations',
                value: self.scheduledDonations
              }
            ]
          })
        })
      }
    }
  }
</script>

<style scoped>
  .profile-label {
    padding: 4px 0;
  }

  .profile-textfield {
    margin-top: -20px;
  }
</style>



// WEBPACK FOOTER //
// ParametersForm.vue?0b58a95e